import { render, staticRenderFns } from "./SettingsNormal.vue?vue&type=template&id=ecef4f6c&lang=pug&"
import script from "./SettingsNormal.vue?vue&type=script&lang=ts&"
export * from "./SettingsNormal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports